module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('h2', {
    staticClass: "chtit"
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chavasse wore a sheepskin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shuba")]), _vm._v(" wrapped closely around him, sheepskin boots and a hat of some indeterminate fur, flaps down over his ears. He cradled a British Lee Enfield rifle in one arm and allowed the hardy mountain pony to find its own way. He thought he heard a plane at one point, but could not be sure as the sound faded rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Land of Snows the Tibetans called this part of the border area, and it was well named, a living nightmare of a place with passes through the mountains as high as twenty thousand feet. It was not uncommon for mules in the caravans in the old days to die of asthma and for their masters to get pulmonary edema as their lungs filled with water.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("An ironic way to die, Chavasse thought, to ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("drown while standing up. Of course, it didn’t matter these days. There were no more caravans to India, by Chinese decree.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It started to snow again lightly and he paused to check the ground ahead. The sky being blanketed by low swollen clouds, there was no snow glare. He had spent the previous night in a herdsman’s cave, sheltering from a sudden blizzard, and had started again at first light. Now, the pass between the peaks emptied onto a final slope that ran down towards the Indian border. In fact, in the far distance there was a flicker of colour, obviously a flag, and Chavasse urged his pony forward.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The border post was quite simple. A large stone hut, no barbed wire, no defence system. Half a dozen Indian soldiers stood outside wearing white winter combat uniforms, the hoods pulled up over their turbans. There was a jeep painted in white camouflage, and the young man leaning against it smoking a cigarette came forward and looked up at Chavasse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mr. Chavasse? I am Lieutenant Piroo. We heard over the radio from Tibetan freedom fighters that you were coming.” He smiled. “I’m surprised that there are any left, if the reports we get of Chinese reaction are true.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Chavasse heaved himself out of the saddle and a soldier led the pony away. “Oh, they’re true all right. They’re killing people by the thousands, ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("wiping out whole villages.” Piroo gave him a cigarette and lit it for him and Chavasse continued. “No, I’m afraid this time they intend to wipe out Tibetan resistance once and for all.”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which is why the Dalai Lama has fled?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, he hopes to continue the struggle from India. Do you think Prime Minister Nehru will accept him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yes, that has been made quite clear. But come, Mr. Chavasse, my boss is waiting to see you at Gela. That’s about ten miles from here.” He smiled. “And only sixteen thousand feet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse got into the jeep and Piroo slipped behind the wheel. “And who might your boss be?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Colonel Ram Singh. Very correct and old school. Even went to Sandhurst.” Piroo, in spite of the jeep sliding from side to side on the rough track, found another cigarette and lit it onehanded. “I thought the CIA were to do great things? Help the rebels and so on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They dropped in a certain amount of arms,” Chavasse told him. “Mostly British, because they didn’t want the Chinese to make an American connection. Other than that, they haven’t done much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you have, Mr. Chavasse. British intelligence still functions, it would seem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So they tell me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“I understand you were told by the Indian ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("government not to cross the border, but went anyway?”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And Major Hamid went with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Also true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Piroo shook his head. “Crazy Pathan. They’ll court-martial him for this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No they won’t. He’s behind me right now with the Dalai Lama. I only came ahead to confirm their arrival time. Hamid will be an instant hero to every Indian on this continent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perhaps not, my friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what do you mean by that?” Chavasse demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, that’s for my boss to tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse sat there, frowning, and they came over a rise and saw a number of Nissen huts below beside an airstrip. The aircraft parked at one end had twin engines and was painted white.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A Navajo,” Chavasse said. “What’s that doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A quick link with the lowlands. Supplies, communications. The Airstair door means we can get stretchers in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And why the white strip?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So that if I stray over the border it will make it more difficult for the Chinese to shoot me down.” Piroo smiled. “Oh, yes, Mr. Chavasse. I am the pilot. Indian air force, not army,” and he drove down the track.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("It was warm in the Nissen hut as the four officers and Chavasse leaned over the map on the table. Colonel Ram Singh was small and fierce with a thin moustache, the medal ribbons on his shirt making a fine show.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not good, Mr. Chavasse, not good. I can tell you unofficially that Prime Minister Nehru and the Indian government are prepared to receive the Dalai Lama. Piroo here was to fly him out as soon as he arrived.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which isn’t likely now, I’m afraid,” Piroo said. “I made an overflight—quite illegally, of course.” His finger touched the map. “Here is the Dalai Lama’s column. I’d estimate by now about fifteen miles to go.” He indicated again. “And here, twenty-five miles behind them, a Chinese column coming up fast—jeeps, not horses. Certain to catch them before the border.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse examined the map carefully. “When did you see all this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“An hour ago. Not much more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse nodded. “I came that way myself. The terrain is terrible. Even a jeep is lucky to cover ten miles in an hour. Rough ground and boulders everywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So?” Ram Singh said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“That means the Chinese are still on the other side of the Cholo Gorge. Hundreds of feet deep. There’s an old wooden bridge there. It’s the only ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("way across. Destroy that and they’ve had it. The Dalai Lama will be home free.”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“An attractive idea, Mr. Chavasse, but if you are suggesting that Lieutenant Piroo should somehow bomb their bridge, I must say no. Chinese territory, that is what they claim, and we are not at war with China.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well I am.” Chavasse turned to Piroo. “You carry parachutes on that thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse said to Ram Singh, “Meet me halfway, Colonel. You’ve already allowed Piroo to fly over there. Let him volunteer again. You find me some explosives. On the way in we drop a message to the Dalai Lama’s column to alert Hamid as to what’s going on, then I’ll parachute in at the bridge and blow it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what happens after?” Piroo demanded. “You’ll be all alone out there on foot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hopefully Hamid will ride back for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a long silence as all the officers exchanged glances. The colonel looked down at the map, drumming his fingers on it. He glanced up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You would do this, Lieutenant?” he asked Piroo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My pleasure, Colonel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Madness,” Ram Singh said. “Total madness.” Suddenly he smiled. “We’d better get cracking, Mr. Chavasse. Not much time.”")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Ram Singh said, “A very simple explosive, Mr. Chavasse.” He opened an army haversack and produced one of several dark green blocks. “We get it from the French army.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Plastique,” Chavasse said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Totally harmless until used in conjunction with one of these timer pencils.” Ram Singh held a few up. “Five-minute fuses, but the two with yellow ends are two minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The haversack was put on Chavasse’s back, then he pushed his arms through the straps. One of the officers helped him into a parachute, another gave him a Sten gun with two magazines taped together, which he draped across his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ram Singh picked up a weighted signal can with a great scarlet streamer attached to it. “The message for Major Hamid. It tells him exactly what you intend.” Ram Singh put a hand on Chavasse’s shoulder. “I hope he finds it possible to … how shall I put it … to retrieve you, my friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s a Pathan,” Chavasse said simply. “You know what they’re like. He’d walk into the jaws of hell just to have a look.” He smiled. “I’d better get moving.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Ram Singh pulled on a parka and led the way out. It was snowing a little, loose flakes on the wind and very cold. They crossed to the Navajo, where Piroo already had the engines warming ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("up. Chavasse paused at the bottom of the Airstair door and Ram Singh shook hands and saluted.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“As God wills, my friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse smiled, went up the steps and pushed the door shut. Piroo glanced over his shoulder and boosted power, then they roared along the airstrip and lifted off.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In spite of the layers of clothing he wore, Chavasse was cold—very cold—and he found breathing difficult. He looked out of the window to a landscape as barren as the moon, snow- covered peaks on either side. Now and then they dropped sickeningly in an air pocket, and they were constantly buffeted by strong winds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Piroo glanced over his shoulder and shouted above the roar of the engines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll curve round to the gorge first. Let’s make sure the Chinese are still on the other side before we communicate with Hamid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine,” Chavasse told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They entered a low cloud which enveloped them for five minutes. Then they came out on the other side and there was the gorge below, the bridge in clear view. Even clearer was the Chinese column perhaps a quarter of a mile on the other side, racing towards the bridge very fast over what was at that point a flat plain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No time to hang around. They’ll be at the bridge in ten minutes,” Chavasse shouted. “I’m on my way. Take me down to five hundred.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Piroo dropped the nose, and the Navajo went down and levelled out. Chavasse moved awkwardly because of the bulk of his equipment and released the Airstair door. There was a great rush of air. He waited until they were as close to the bridge as possible, then tumbled out headfirst.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Hamid dismounted and waited while one of the Tibetan freedom fighters galloped to where the signal can lay on the snow, the scarlet streamer plain. The man leaned down from the saddle, picked up the can and galloped back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hamid was a typical Pathan, a large man, very tall, dark-skinned and with a proud look to his bearded face. Behind him the column had stopped as everyone waited. The horsemen arrived and handed over the can. Hamid opened it and took out the message and read it. He swore softly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From behind, a voice called, “What is it, Major Hamid?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Dalai Lama, covered by sheepskins, lay on a kind of trailer pulled by a horse, for he was too ill to ride.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s from Chavasse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So he got through?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Unfortunately there’s a Chinese column very close to us on the other side of the Cholo Gorge. It would seem Chavasse has dropped in by parachute in an effort to blow the bridge. I must go to his aid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I understand,” the Dalai Lama said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“Good. I’ll take two of the escorts with me. The rest of you must press on with all possible speed.”")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He rode across to one of the carts and picked up a Bren gun and two magazines, which he stuffed into his saddlebag, then he gave a quick order to two of the Tibetans and galloped away. A few moments later, leading a spare horse, they went after him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Chavasse hit the ground heavily perhaps a hundred yards from the bridge. He lay there for a moment, winded, then stood up and struggled out of his parachute harness. There was still no sign of the Chinese and he unslung the Sten gun and ran along the uneven track between outcrops of rock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was stupid, of course, such exertion of that altitude, and by the time he reached the bridge he was gasping for air, his breath like white smoke. He started across and it swayed gently. He got to the centre, took off the haversack and selected a block of plastique, inserted a five- minute timer, lay down and reached over the edge and wedged the explosive into a space between the ends of two struts. He activated the timer and stood up, and at that moment a Chinese jeep appeared on top of the rise on the other side.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Its machine gun opened up at once. Chavasse ran, the Sten gun in one hand, the haversack in ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("the other. He reached the end of the bridge, ducked behind one of the supporting posts, found another block of plastique, inserted a yellow two-minute fuse and activated it.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The jeep kept firing, bullets clipping wood from the post. He laid the plastique block down and returned fire with his Sten, and a lucky shot knocked one soldier out. The jeep, halfway across the bridge, paused, with another just behind it, and on the ridge above the rest of the column arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just stay there,” Chavasse prayed, and tossed the block of plastique out onto the bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To his horror, it actually bounced over the edge, where it exploded in space. Firing relentlessly, the jeep started forward, followed by the other, and the column moved down on the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse ran up amongst the rocks, head down, glancing back to see the two jeeps reach firm ground. At that moment and just as the convoy started across, there was a huge explo-sion. The centre of the bridge twisted up into the air, lengths of timber flying everywhere. The two lead jeeps in the convoy on the other side went with it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("As the reverberations died away there were cries of rage from the Chinese in the two jeeps that had got across, three soldiers in one and four in the other. They fired their light machine guns into the rocks below the escarpment and Chavasse ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("cowered down and opened his haversack. There was one block of plastique left. He inserted the remaining two-minute pencil and started to count, the Sten gun ready in his other hand.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He fired it in short sharp bursts with his left hand, still counting, and the soldiers raked the rocks with machine-gun fire so fierce that he had to keep his head down and hurl the block of plastique blindly. This time his luck was good, for it landed in the jeep containing four soldiers and exploded a second later, with devastating effect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He glanced over a rock and saw only carnage. The four soldiers had been killed outright and the other jeep tilted on one side, its three occupants having been thrown from it. As Chavasse watched, they got to their feet, coughing in the acrid smoke, and picked up their weapons. He stood and opened fire with the Sten, three bullets kicking up dirt beside them. Then the magazine simply emptied itself. He threw it down, turned and ran for his life as the three Chinese cried out and came after him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bullets ploughed into the ground beside him, kicking up snow as he struggled up the slope, and then a cheerful voice cried, “Lie down, Paul, for God’s sake.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Hamid appeared on the ridge above, holding the Bren light machine gun in both hands. He swept it from side to side, cutting down the three ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Chinese in a second. As the echoes died away, he looked at the ruins of the bridge.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now that’s what I call close.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could say that.” Chavasse scrambled up the slope and saw the two Tibetans below holding Hamid’s horse and the spare. “How thoughtful—you’ve brought one for me. Prime Minister Nehru and the Indian government are prepared to receive the Dalai Lama. The Indian air force plane that just dropped me in will be waiting on the airstrip at Gela. We’ll all be in Delhi before you know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excellent,” Hamid said. “So can we kindly get the hell out of here?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The British embassy in Delhi was ablaze with light, crystal chandeliers glittering, the fans in the ceiling stirring the warm air, the French windows open to the gardens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ballroom was packed with people, anyone who counted in Delhi, the great and the good, not only the British ambassador, but Prime Minister Nehru, all there to honour the Dalai Lama, who sat in a chair by the main entrance, greeting the well-wishers who passed him in line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse, in a white linen suit, black shirt and pale lemon tie, stood watching. Hamid was at his side, resplendent in turban and khaki uniform, his medal ribbons, particularly the Military Cross from the British, making a brave show.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“Look at them,” Chavasse said. “All they want ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("to do is to be able to boast that they shook his hand. They’d ask for his autograph if they dared.”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“The way of the world, Paul,” the Pathan told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a Chinese in the line, a small man with horn-rimmed glasses, an eager smile on his face. Chavasse stiffened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young lieutenant behind them said, “His name is Chung. He’s a doctor. Runs a clinic for the poor. He’s Chinese Nationalist from Formosa. Came here six months ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. Chung took the Dalai Lama’s hand. “Chung—Formosa, Holiness,” they heard him say. “Such an honour.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Dalai Lama murmured a response, and Chung moved away and took a glass from a tray held by one of the many turbanned waiters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Dalai Lama beckoned the young lieutenant, and said to him, “Enough for the moment. I think I’ll have a turn in the garden. I could do with some fresh air.” He smiled at Chavasse and Hamid. “I’ll see you again in a little while, gentlemen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Escorted by the lieutenant, he made his way through the crowd, nodding and smiling to people as he passed, then went out through one of the French windows. The lieutenant returned.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“He seems tired. I’ll just go and tell them at ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("the door to warn new guests that he’s not available for presentation.”")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He walked away and Hamid said, “When do you return to London?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse lit a cigarette. “Not sure. I’m waiting for orders from my boss.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ah, the Chief, the famous Sir Ian Moncrieff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not supposed to know that,” Chavasse said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you’re certainly not,” a familiar voice said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse swung round in astonishment and found Moncrieff standing there. He wore a crumpled sand-coloured linen suit and a Guards tie, and his grey hair was swept back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where on earth did you spring from?” Chavasse demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The flight from London that got in two hours ago. Magnificent job, Paul. Thought I’d join in the festivities.” He turned to the Pathan. “You’ll be Hamid?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They shook hands. “A pleasure, Sir Ian.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moncrieff took a glass from the tray of a passing waiter and Chavasse said, “Well, they’re all here, as you can see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moncrieff drank some of the wine. “Including the opposition.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean?” Hamid asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our Chinese friend over there.” Moncrieff indicated Chung, who was working his way through the crowd towards the French windows.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("“Chinese Nationalist from Formosa,” Chavasse said. “Runs a clinic for the poor downtown.”")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, if that’s what Indian intelligence believe they’re singularly ill-informed. I saw his picture in a file at the Chinese Section of SIS in London only last month. He’s a Communist agent. Where’s the Dalai Lama, by the way?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the garden,” Hamid told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that moment Chung went out through one of the open French windows. “Come on,” Chavasse said to Hamid, and pushed his way quickly through the crowd. The garden was very beautiful—flowers everywhere, the scent of magnolias heavy on the night air, palm trees swaying in a fight breeze. The spray from a large fountain in the centre of the garden lifted into the night and the Dalai Lama followed a path towards it, alone with his thoughts. He paused as Dr. Chung stepped from the bushes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Holiness, forgive me, but your time has come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He held an automatic pistol in one hand, a silencer on the end. The Dalai Lama took it in and smiled serenely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I forgive you, my son. Death comes to all men.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Hamid, running fast, Chavasse at his back, was on Chung in an instant, one arm around his neck, a hand reaching for the right wrist, depressing the weapon towards the ground. It fired once, a dull thud, and Chung, struggling desperately, managed to turn. For a moment they were ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("breast to breast, the tall Pathan and the small Chinese. After another dull thud, Chung went rigid and slumped to the ground. For a moment he lay there kicking, then he went very still.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Chavasse went down on one knee and examined him as Moncrieff arrived on the run. Chavasse stood up, the gun in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is he dead?” the Dalai Lama asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” Chavasse told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“May his soul be at peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d suggest you come with me, sir,” Moncrieff said. “The fewer people who know about this the better. In fact it never happened, did it, Major?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll handle it, sir,” Hamid said. “Utmost discretion. I’ll get the head of security.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moncrieff took the Dalai Lama away. Hamid said, “Pity the poor sod decided to shoot himself here, and we’ll never know why, will we? As good a story as any. You stay here, Paul. You’ll make a fine witness, and so will I.” He shook his head. “Peking has a long arm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Pathan hurried away and Chavasse lit a cigarette and went” and sat on a bench by the fountain and waited.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa536ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter02.vue
// module id = 75
// module chunks = 0